import React from 'react'
import healthcare1 from '../images/orangehrm1.png';
import healthcare2 from '../images/orangehrm2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function OrangeHRM() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">OrangeHRM</span> – Customised Human Resource Management Software & Integrated Office Management ERP System
                    </div>



                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Remente App Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">OrangeHRM</span> – Customised Human Resource Management & Integrated Office ERP System
                        </h1>

                        <p className="mb-3 ps-1">
                            OrangeHRM is a comprehensive HR and office-management ERP solution designed to unify workforce operations, administrative workflows,
                            and organizational processes within a single, integrated platform. It helps organizations centralize employee data, automate HR tasks,
                            and manage office operations seamlessly — improving efficiency, transparency, and control.
                        </p>

                        <p className="mb-3 ps-1">
                            From attendance and payroll automation, recruitment workflows, performance tracking, and asset management to procurement, internal task
                            management, and department-wide coordination — OrangeHRM enables businesses to operate with a fully integrated digital ecosystem.
                            The platform empowers teams to streamline operations, maintain compliance, and scale with ease.
                        </p>

                        <p className="mb-3 ps-1 fw-bold">
                            <span className="highlight-orange">Proven Impact:</span> Companies leveraging OrangeHRM’s integrated HR + ERP system report
                            <span className="highlight-orange"> a 40–60% reduction in manual administrative workload</span>, significantly fewer errors in HR and
                            office operations, and <span className="highlight-orange">up to 3× ROI within the first 6 months</span>. With centralized data, automated workflows,
                            and real-time insights, businesses gain improved productivity, operational control, and long-term scalability.
                        </p>


                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> OrangeHRM
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            HR Automation Engine, ERP Workflow Management, Attendance & Payroll System, React, Node.js, Firebase,
                            REST APIs, Role-Based Access Control, Performance & Recruitment Modules, Real-Time Analytics Dashboard
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">Human Resource Management System & Office Management ERP</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Developer, Automation Engineer, Database Architect, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">3 Months</p>

                        <p className="mb-4 ps-3">
                            OrangeHRM is a fully customised HR management and office automation ERP platform developed to streamline
                            end-to-end workforce operations. The system centralizes employee data, attendance, payroll, leave management,
                            recruitment workflows, performance tracking, and internal communication under a unified interface.
                            Additionally, integrated ERP modules – including asset management, task coordination, document control, and
                            department-level workflow automation – ensure seamless organizational operations.

                            Designed for mid-scale and enterprise environments, OrangeHRM improves administrative accuracy, reduces manual
                            workload, and enables HR teams and management to make fast, data-driven decisions. With real-time analytics,
                            automated process flows, and multi-module connectivity, the platform enhances productivity, compliance, and
                            scalability across the entire organization.
                        </p>




                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Remente UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Mental Wellness Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We developed the customised OrangeHRM platform with a modern HR-first architecture integrated seamlessly with
                            office management ERP workflows. The system was engineered to centralize all HR and administrative functions —
                            including attendance, payroll, recruitment, performance evaluation, asset tracking, task management, and document
                            control — into a unified, automated digital ecosystem. Our backend ensures secure data handling, fast processing,
                            and smooth real-time synchronization across HR and ERP modules for uninterrupted organizational operations.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was designed to simplify complex HR and office management activities, offering a clean, intuitive,
                            and role-based interface for employees, HR teams, department heads, and top management. With guided workflows,
                            automation-driven interactions, and visually rich dashboard insights, the system empowers organizations to
                            operate efficiently without technical dependencies — reducing workload and eliminating repetitive manual tasks.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Automated HR workflows: attendance, payroll, onboarding & exit management</li>
                            <li className="mb-1">Leave, shift & roster management with real-time approvals</li>
                            <li className="mb-1">Recruitment & applicant tracking with automated screening and evaluation</li>
                            <li className="mb-1">Performance management system with KPI-based tracking and reporting</li>
                            <li className="mb-1">Integrated office ERP modules: task assignment, asset tracking, document management</li>
                            <li className="mb-1">Centralized multi-department data syncing for smooth organizational collaboration</li>
                            <li className="mb-1">Real-time dashboards with analytics for HR, admin, and department heads</li>
                        </ul>



                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default OrangeHRM